import * as sell from 'model/actions/utilities/_sell';
import { formatMessage } from 'model/message';

const MAX_SELL_AMMO = 10;

const messageText = ({ cost, gain }) => {
  return formatMessage('sold ammo', { cost, gain });
};

const value = (max, resultsVariable) => (resultsVariable ? Math.floor(Math.random() * max) : max);

const attempt = (price, resultsVariable) => {
  const cost = {
    ammo: value(MAX_SELL_AMMO, resultsVariable)
  };
  return sell.attempt(cost, price);
};

const sellAmmo = ({ context, resultsVariable }) => {
  // TODO: Use maxQuantity to limit the amount that the merchant will buy
  const [maxQuantity, price] = sell.adjustQuantityAndCost(context, 'ammo');

  return {
    title: 'Sell Ammo',
    cooldown: 0.2,
    enabled: () => context.party.resources.attribs.ammo.value >= MAX_SELL_AMMO,
    execute: context => {
      const result = attempt(price, resultsVariable);

      sell.executeSideEffects(context, result);

      return { result: { message: messageText(result) } };
    },
    tooltips: [['coins', `${price}`]]
  };
};

export default sellAmmo;
